import { Box, Container, Typography, Grid, Card, Rating, Avatar, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

const Reviews = () => {
  const theme = useTheme();

  const reviews = [
    {
      name: 'Thomas M',
      role: 'Army Veteran',
      rating: 5,
      review: 'Fast and Easy is an understatement, my vehicle was picked up the same day and everyone was so friendly!',
      image: '/avatars/thomas.jpg',
    },
    {
      name: 'Angelo V',
      role: 'Navy Veteran',
      rating: 5,
      review: 'I was assisted getting my car picked up, it didn’t run but was picked up quickly',
      image: '/avatars/angelo.jpg',
    },
    {
      name: 'Charles G',
      role: 'Marine Corps Veteran',
      rating: 5,
      review: 'I like how easy it was and very happy with the results and that it my vehicle went to a GREAT cause!',
      image: '/avatars/charles.jpg',
    },
  ];

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
          pt: { xs: '100px', sm: '120px', md: '140px' },
          pb: { xs: '40px', sm: '60px', md: '80px' },
          px: { xs: 2, sm: 4, md: 0 },
          color: 'white',
        }}
      >
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography 
              variant="h1" 
              sx={{ 
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                fontWeight: 800,
                mb: { xs: 2, md: 3 },
                textAlign: 'center',
                textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
              }}
            >
              Success Stories
            </Typography>
            <Typography 
              variant="h5" 
              align="center"
              sx={{ 
                maxWidth: 800,
                mx: 'auto',
                opacity: 0.9,
                lineHeight: 1.6,
              }}
            >
              Hear from veterans and donors about their experiences with Vehicles For Young Veterans
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Reviews Grid */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Grid container spacing={{ xs: 3, sm: 4, md: 6 }}>
          {reviews.map((review, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card
                  elevation={0}
                  sx={{
                    height: '100%',
                    p: { xs: 3, sm: 4 },
                    borderRadius: 2,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar
                      src={review.image}
                      alt={review.name}
                      sx={{
                        width: 64,
                        height: 64,
                        mr: 2,
                        border: `2px solid ${theme.palette.primary.main}`,
                      }}
                    />
                    <Box>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {review.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {review.role}
                      </Typography>
                    </Box>
                  </Box>
                  <Rating value={review.rating} readOnly sx={{ mb: 2 }} />
                  <Typography 
                    variant="body1" 
                    color="text.secondary"
                    sx={{ 
                      lineHeight: 1.7,
                      fontStyle: 'italic',
                      position: 'relative',
                      pl: 3,
                      '&::before': {
                        content: 'open-quote',
                        position: 'absolute',
                        left: 0,
                        fontSize: '2rem',
                        color: theme.palette.primary.main,
                        lineHeight: 1,
                      },
                      '&::after': {
                        content: 'close-quote',
                        fontSize: '2rem',
                        color: theme.palette.primary.main,
                        lineHeight: 1,
                        ml: 1,
                      },
                    }}
                  >
                    {review.review}
                  </Typography>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Veterans Image Section */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
          py: { xs: 6, md: 8 },
          color: 'white',
          textAlign: 'center',
          overflow: 'hidden',
        }}
      >
        <Container maxWidth="lg" sx={{ overflow: 'hidden' }}>
          <Typography 
            variant="h2" 
            sx={{ 
              mb: { xs: 3, md: 4 },
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
              fontWeight: 700,
              textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
            }}
          >
            Supporting Our Veterans
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={6}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <Card
                  sx={{
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    maxWidth: '100%',
                  }}
                >
                  <Box
                    component="img"
                    src="/images/IMG_9726.jpeg"
                    alt="Veterans Support"
                    sx={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '400px',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </Card>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Reviews;
